import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { appendToAssistantDetail } from '../../store/app/assistantSlice';

function EvaluationComponent() {

    const dispatch = useDispatch();
    const assistantDetails = useSelector((state) => state.assistants.activeDetail.details);

    const RUBRIC_SUFFIX = `\n\nRubric:\n\n{{rubric}}\n\nOnly respond with the evaluation result.`;

    const initialContent =
        assistantDetails?.analysisPlan?.successEvaluationPlan?.messages?.[0]?.content || '';
    const rubricFromPlan = assistantDetails?.analysisPlan?.successEvaluationPlan?.rubric || '';

    const cleanedPrompt = initialContent.endsWith(RUBRIC_SUFFIX)
        ? initialContent.replace(RUBRIC_SUFFIX, '')
        : initialContent;

    const [prompt, setPrompt] = useState(cleanedPrompt);
    const [rubric, setRubric] = useState(rubricFromPlan);

    useEffect(() => {
        if (!prompt && !rubric) return;

        const effectiveRubric = rubric === '' ? 'PassFail' : rubric;

        const existingPlans = assistantDetails?.analysisPlan || {};

        const updatedAnalysisPlan = {
            ...existingPlans,
            successEvaluationPlan: {
                rubric: effectiveRubric,
                messages: [
                    {
                        role: 'system',
                        content: prompt.replace('{{rubric}}', effectiveRubric),
                    },
                ],
            },
        };

        dispatch(appendToAssistantDetail({ analysisPlan: updatedAnalysisPlan }));

        if (rubric === '') {
            setRubric('PassFail');
        }
    }, [prompt, rubric, dispatch, assistantDetails?.analysisPlan]);


    const rubricOptions = [
        {
            value: 'NumericScale',
            label: 'NumericScale',
            description: 'A scale of 1 to 10.',
        },
        {
            value: 'DescriptiveScale',
            label: 'DescriptiveScale',
            description: 'A scale of Excellent, Good, Fair, Poor.',
        },
        {
            value: 'Checklist',
            label: 'Checklist',
            description: 'A checklist of criteria and their status.',
        },
        {
            value: 'Matrix',
            label: 'Matrix',
            description: 'A grid that evaluates multiple criteria across different performance levels.',
        },
        {
            value: 'PercentageScale',
            label: 'PercentageScale',
            description: 'A scale of 0% to 100%.',
        },
        {
            value: 'LikertScale',
            label: 'LikertScale',
            description: 'A scale of Strongly Agree, Agree, Neutral, Disagree, Strongly Disagree.',
        },
        {
            value: 'AutomaticRubric',
            label: 'AutomaticRubric',
            description: 'Automatically break down evaluation into several criteria, each with its own score.',
        },
        {
            value: 'PassFail',
            label: 'PassFail',
            description: 'A simple pass or fail evaluation.',
        },
    ];


    return (
        <div className="card">
            {/* Header */}
            <div style={{ borderTopRightRadius: '8px', borderTopLeftRadius: '8px', backgroundColor: '#f1f3f5', padding: '10px 20px' }}>
                <div style={{ fontWeight: 500 }}>Success Evaluation</div>
                <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '4px' }}>
                    Evaluate if your call was successful. You can use Rubric standalone or in combination with the Success Evaluation Prompt.
                </div>
            </div>

            {/* Body */}
            <div>
                {/* Prompt */}
                <div style={{ padding: '10px 20px' }}>
                    <div>Prompt</div>
                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                        This is the prompt used to evaluate if the call was successful.
                    </div>
                    <textarea
                        id="agent-prompt"
                        className="agent-form-textarea agent-form-textarea::placeholder"
                        placeholder={prompt === "" ? "You are an expert call evaluator. You will be given a transcript of a call and the system prompt of the Al participant. Determine if the call was successful based on the objectives inferred from the system prompt." : prompt}
                        style={{ height: '300px' }}
                        value={prompt}
                        onChange={(e) => setPrompt(e.target.value)}
                    />
                </div>

                {/* Rubric */}
                <div style={{ padding: '10px 20px' }}>
                    <div>Success Evaluation Rubric</div>
                    <div style={{ fontSize: '12px', color: '#6b7280', marginBottom: '4px' }}>
                        This enforces the rubric of the evaluation.
                    </div>
                    <select
                        className="form-select"
                        value={rubric}
                        onChange={(e) => setRubric(e.target.value)}
                        style={{
                            backgroundPosition: 'right 1.25rem center',
                            paddingRight: '2.25rem',
                            fontSize: '14px',
                            lineHeight: '1.2rem',
                        }}
                    >
                        <option value="">Select Evaluation Rubric</option>
                        {rubricOptions.map((option) => (
                            <option key={option.value} value={option.value}>
                                {`${option.label} — ${option.description}`}
                            </option>
                        ))}
                    </select>

                </div>
            </div>
        </div>
    );
}

export default EvaluationComponent;
